/** Montant ticket minimal aligné BonSpot (LOYALTY_TICKET_MIN_XAF). */
export const LOYALTY_PASS_TICKET_MIN_XAF = 100;

/**
 * Normalise le montant ticket pour recordVisitFromSale.
 * Les ventes &lt; 100 FCFA comptent quand même un passage (plancher).
 */
export function ticketAmountForPassVisit(finalTotal: number): number {
  const n = Math.round(Number(finalTotal) || 0);
  return Math.max(LOYALTY_PASS_TICKET_MIN_XAF, n);
}
